<template>
  <div class="d-flex flex-column">
    <ChargingCurvesSearchOptions @onSearchInput="handleOnSearchInput" />
    <div class="d-flex justify-content-end">
      <el-button
        type="primary"
        class="download-csv-button"
        @click="exportList"
        :disabled="!(query.cpe && query.monthYear)"
      >
        <font-awesome-icon icon="fa-light fa-file-csv" class="mr-2" />
        {{ $t("sections.common.pagination.downloadCsvButton") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChargingCurvesSearchOptions from '@/components/sections/ords/ChargingCurvesSearchOptions';

export default {
  name: 'ChargingCurves',
  components: {
    ChargingCurvesSearchOptions,
  },
  data() {
    return {
      query: {},
    };
  },
  computed: {
    ...mapGetters(['getLoading']),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);

      // TODO

      this.$store.dispatch('storeLoading', false);
    },
    async handleOnSearchInput(evt) {
      this.query = evt;
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportChargingCurves', {
          query: { ...this.query },
          type: 'chargingCurves',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'chargingCurves' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `chargingCurves-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'chargingCurves' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'chargingCurves' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.download-csv-button {
  font-weight: 600;
  width: 180px;

  i,
  svg {
    font-size: 18px;
  }
}
</style>
